import { FC } from 'react';
import { Skeleton } from 'antd';

type SkeletonComponentProps = {
	loading: boolean;
	children: JSX.Element;
};
export const SkeletonComponent: FC<SkeletonComponentProps> = ({ loading, children }) => {
	return (
		<Skeleton loading={loading} active>
			{children}
		</Skeleton>
	);
};
